var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.85791 4.48072L9.02283 10.007C9.684 10.4545 10.0146 10.6783 10.3742 10.7649C10.6918 10.8415 11.024 10.8415 11.3416 10.7649C11.7012 10.6783 12.0318 10.4545 12.693 10.007L20.8579 4.48072M5.65791 17.0505H16.0579C17.7381 17.0505 18.5781 17.0505 19.2199 16.7343C19.7844 16.4562 20.2433 16.0125 20.5309 15.4667C20.8579 14.8462 20.8579 14.0339 20.8579 12.4094V6.22115C20.8579 4.5966 20.8579 3.78432 20.5309 3.16382C20.2433 2.61802 19.7844 2.17426 19.2199 1.89616C18.5781 1.58 17.7381 1.58 16.0579 1.58H5.65791C3.97775 1.58 3.13767 1.58 2.49594 1.89616C1.93145 2.17426 1.47251 2.61802 1.18489 3.16382C0.85791 3.78432 0.85791 4.5966 0.85791 6.22115V12.4094C0.85791 14.0339 0.85791 14.8462 1.18489 15.4667C1.47251 16.0125 1.93145 16.4562 2.49594 16.7343C3.13767 17.0505 3.97775 17.0505 5.65791 17.0505Z",
    stroke: "#484C50",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.bd2b5653499824035efb722a7250b0a7.svg";
export { ForwardRef as ReactComponent };